(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("smartdown", [], factory);
	else if(typeof exports === 'object')
		exports["smartdown"] = factory();
	else
		root["smartdown"] = factory();
})(self, () => {
return 